/**
 * Square composite tiles in the same column count as KPI tiles.
 */

import React from 'react';
import { CompositeCard } from './CompositeCard';
import { kpiGridClass, type CompositeCard as CompositeCardModel } from './types';

interface CompositeGridProps {
  cards: CompositeCardModel[];
  columns: number;
  t: (key: string) => string;
  onHide?: (id: string) => void;
}

export const CompositeGrid: React.FC<CompositeGridProps> = ({ cards, columns, t, onHide }) => {
  if (cards.length === 0) return null;
  return (
    <div className={`grid gap-1 items-start ${kpiGridClass(columns)} mb-2`}>
      {cards.map((card) => (
        <CompositeCard
          key={card.id}
          card={card}
          t={t}
          onHide={onHide ? () => onHide(card.id) : undefined}
        />
      ))}
    </div>
  );
};
